import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assinatura-eletronica',
  templateUrl: './assinatura-eletronica.component.html',
  styleUrls: ['./assinatura-eletronica.component.scss']
})
export class AssinaturaEletronicaComponent implements OnInit {



  constructor(private authService: AuthenticationService,
    private router: Router) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/assinatura-eletronica/assinatura-eletronica.component.ts